import { put, takeLatest } from 'redux-saga/effects';
import { FetchStatus } from 'data/core';
import { saveNormalizedTask } from 'data/tasks/slice';
import { spaceTabSuccessSagaAction } from '../actions';
import { saveNormalizedSpaceTabs } from '../index';
import { spaceTabNormalizer } from '../schema';
function* spaceTabSuccessSaga({ payload }) {
    const { entities: { spaceTabs, tasks } } = spaceTabNormalizer(payload);
    if (tasks) {
        yield put(saveNormalizedTask({
            data: tasks,
            fetchStatus: FetchStatus.Partial
        }));
    }
    if (spaceTabs) {
        yield put(saveNormalizedSpaceTabs({
            data: spaceTabs,
            fetchStatus: FetchStatus.Loaded
        }));
    }
}
export function* watchSpaceTabSuccessSaga() {
    yield takeLatest(spaceTabSuccessSagaAction.type, spaceTabSuccessSaga);
}
